<template>
  <div id="author-revised-replay">
    <div class="ipub-h2 mar-b-20">Reviewer {{detail.seq}} - Report</div>
    <div class="content-bg"
         style="padding-bottom:10px">
      <div class="mar-b-10">
        <div class="ipub-h3 mar-b-10 ipub-title-tab line-h-40">
          Manuscript Information
        </div>
        <div class="ipub-title-tab-part">
          <div style="margin-bottom:12px"
               class="flex">
            <div class="ipub-p2 fw-bd"
                 style="width:180px">Article Title: </div>&nbsp;
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{detail.title}}</div>
          </div>
          <div class="flex"
               style="margin-bottom:12px">
            <div class="ipub-p2 fw-bd"
                 style="width:180px">Journal: </div>&nbsp;
            <div class="ipub-p2">{{detail.journal && detail.journal.fullName}}</div>
          </div>
          <div class="flex"
               style="margin-bottom:12px">
            <div class="ipub-p2 fw-bd"
                 style="width:180px">Manuscript No.: </div>&nbsp;
            <div class="ipub-p2">{{detail.code}}</div>
          </div>
          <div class="flex"
               style="margin-bottom:12px">
            <div class="ipub-p2 fw-bd"
                 style="width:180px">Article Type: </div>&nbsp;
            <div class="ipub-p2">{{detail.type && detail.type.name}}</div>
          </div>
          <div class="flex"
               v-if="detail.inviteReviewerFileList && detail.inviteReviewerFileList.length">
            <div class="ipub-p2 fw-bd"
                 style="line-height:30px;width:180px">Download Manuscript: </div>&nbsp;
            <div class="ipub-p2">
              <ipub-label size="small"
                          class="ipub-c-p"
                          style="align-items: center;height:30px;margin:0 12px 10px 0"
                          type="link"
                          v-for="(item,index) in detail.inviteReviewerFileList"
                          :key="item.id"
                          @click="download(item,index)">
                {{item.name}}
              </ipub-label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="disableStatu">
        <div class="ipub-h3 mar-b-10 ipub-title-tab line-h-40"
             @click="()=>{replayReport=!replayReport}">Reply Report
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',replayReport?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-if="replayReport">
          <ipub-form ref="author-reply-form"
                     :model="params"
                     :rules="rules">
            <ipub-form-item prop="authorReply"
                            label="Response (Responses here will be send to reviewers)">
              <ipub-textarea v-model="params.authorReply"
                             :autoSize="{ cols: '8', rows: '9' }"
                             placeholder="Enter your response to reviewer 1’s comments…" />
            </ipub-form-item>
          </ipub-form>
          <!-- <div class="ipub-p2 fw-bd mar-b-10">
            Response
            <font class="font-color">(Responses here will be send to reviewers)<font class="key-color">*</font>
            </font>
          </div>
          <ipub-textarea class="mar-b-20"
                         v-model="params.authorReply"
                         :autoSize="{ cols: '8', rows: '9' }"
                         placeholder="Enter your response to reviewer 1’s comments…" /> -->
          <div class="mar-b-30">
            <div class="ipub-p2 fw-bd mar-b-12 flex">
              Attachment(s)
              <div class="ipub-p2 fw-bd">
                <ipub-upload @change="handleUpload"
                             class=" mar-l-20">
                  <span class="ipub-p2 fw-bd link-color ipub-cursor-pointer">
                    <ipub-icon type="iconAdd"
                               style="margin-right:4px" />Add New Attachment(s)
                  </span>
                </ipub-upload>
              </div>
            </div>
            <div class="mar-b-20 ipub-p2">
              <ipub-label v-for="(item, index) in params.authorReplyFileList"
                          class="ipub-p2 mar-b-10"
                          style="margin-right:8px"
                          :key="item.name">
                <a @click="download(item)"
                   class="mar-l-8">
                  {{item.name}}
                </a>
                <ipub-icon @click="delFile(index)"
                           class="mar-l-10"
                           type="iconDelete" />
              </ipub-label>
            </div>
          </div>
          <div class="ipub-p2 mar-b-30">
            <ipub-button type="primary"
                         @click="submit">
              Confirm & Submit
            </ipub-button>
            <ipub-button type="primary"
                         plain
                         @click="()=>{$router.back(-1)}">
              Back
            </ipub-button>
          </div>
        </div>
      </div>

      <!-- <div class="mar-b-20">
        <div class="ipub-h3 mar-b-10 ipub-title-tab line-h-40"
             @click="()=>{reviewQuestion=!reviewQuestion}">Custom Review Questions
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',reviewQuestion?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-show="reviewQuestion"
             class="ipub-title-tab-part">
          <customerReviewQuestion :questionList="detail.questionList"></customerReviewQuestion>
        </div>
      </div> -->
      <div>
        <div class="ipub-h3 mar-b-12 ipub-title-tab line-h-40"
             @click="()=>{commentsAuthor=!commentsAuthor}">
          Comments to Author
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',commentsAuthor?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part"
             v-if="commentsAuthor">
          <div class="ipub-p2 mar-b-20"
               v-if="detail.authorNotes"
               v-html="detail.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
          <template v-else>
            <div class="mar-b-20 line-color">No notes or comments.</div>
          </template>

          <div v-show="detail.reviewerFileList && detail.reviewerFileList.length>0">
            <div class="ipub-p2 fw-bd relative mar-b-12">
              Attachment(s)
            </div>
            <div class="mar-b-20 ipub-p2">
              <ipub-label v-for="item in detail.reviewerFileList"
                          hover
                          class="ipub-cursor-pointer mar-b-10 ipub-p2"
                          style="margin-right:8px"
                          :key="item.name"
                          @click="download(item)">
                {{item.name}}
                <ipub-icon class="mar-l-10"
                           type="iconDownload1" />
              </ipub-label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :isVisable="loading"
             @cancel="cancel"
             :progress="uploadProgress" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
